// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__1ms77","ul":"Sidebar_ul__1-LYT","hideLi":"Sidebar_hideLi__36tCj","li":"Sidebar_li__XEExp","a":"Sidebar_a__3EzI8","liActive":"Sidebar_liActive__1ds_1"};